/* global window */

export function getDataLayer() {
	if (!window.dataLayer) {
		window.dataLayer = [];
	}

	return window.dataLayer;
}

export function triggerEvent(name = '', variables = {}) {
	const dataLayer = getDataLayer();

	const dataLayerVariables = Object.assign({}, variables, { event: name });

	dataLayer.push(dataLayerVariables);
}

export function trackFormView(formName = '') {
	triggerEvent('FormView', { formName });
}

export function trackFormSubmit(formName = '') {
	triggerEvent('FormSubmit', { formName });
}

export function trackSearch(searchTerm, searchCategory = 'not set') {
	triggerEvent('Search', { SearchTerm: searchTerm, SearchCategory: searchCategory });
}

export function trackLinkClick(label = 'not set') {
	triggerEvent('LinkClick', { CustomLinkClickLabel: label });
}

export function trackNewsletterSignup() {
	triggerEvent('NewsletterSignup');
}

export function trackMemberSignup() {
	triggerEvent('MemberSignup');
}

export function trackStickyContactSubmit() {
	triggerEvent('StickyContactSubmit');
}

